<template>
  <page-template>
    <template slot="page-content">
      <div class="news-detail--template page-template bg-beige">
        <div class="relative container-fluid mw9 center">
          <div class="row relative center pt5-ns z-5">
            <div class="col-xs-12 col-sm-7 ph0 pr4-ns w-100">
              <a v-if="post.post_type.is_video == true" class="relative tc" href="#">
                <BgVimeoVideoEmbed
                  class="mt4"
                  v-if="post.vimeo_video_id"
                  :vimeoVideoId="post.vimeo_video_id"
                />
                <img
                  v-else-if="post.featured_image != null"
                  class="dib w-100 relative"
                  v-lazy="post.featured_image"
                />
                <img v-else class="dib w-100 relative" src="'/uploads/refund.jpg'" />
              </a>
              <span v-else>
                <img
                  v-if="post.featured_image != null"
                  class="dib w-100 relative"
                  v-lazy="post.featured_image"
                />
                <img v-else class="dib w-100 relative" v-lazy="'/uploads/refund.jpg'" />
              </span>
            </div>
            <div class="col-sm-5 relative">
              <h1
                v-if="post.html_title && post.html_title != ''"
                class="is-tablet-bold f30px ttn mt4 mt0-m mt0-l is-navy abs-center-ns"
                v-html="post.html_title"
              ></h1>
              <h1
                v-else
                class="is-tablet-bold f30px ttn mt4 mt0-m mt0-l is-navy abs-center-ns"
              >
                {{ post.title }}
              </h1>
            </div>
          </div>
        </div>
        <div class="relative container-fluid mw9 center">
          <div class="row top-sm relative center mb5 z-5">
            <div class="relative col-xs-12 col-sm-6 mt5-ns mb5 ph0">
              <span class="f4 mb5 ttu is-tablet-cond-bold is-navy">{{
                post.date | formatDate
              }}</span>
              <div
                v-if="post.featured_text"
                class="db relative mt3 is-tablet-regular f5 b lh-title cms-content"
                v-html="marked(post.featured_text)"
              ></div>
              <div
                class="db relative mt3 is-tablet-regular f5 lh-title cms-content"
                v-html="marked(post.content)"
              ></div>
              <div
                class="db relative mt3 is-tablet-regular f5 lh-title cms-content"
                v-if="post.buttons"
              >
                <a class="db mw6 mt4 btn-generic has-red-bg" href="https://play.google.com/store/apps/details?id=com.livestyled.outsidelands" title="App Link" v-if="mobileOS === 'Android'"> 
    <span class="text">
    APP STORE LINK
    </span>
    </a>

    <a class="db mw6 mt4 btn-generic has-red-bg" href="https://apps.apple.com/us/app/outside-lands/id547295030" title="App Link" v-else-if="mobileOS === 'iOS'"> 
    <span class="text">
    APP STORE LINK
    </span>
    </a>

    <a class="db mw6 mt4 btn-generic has-red-bg" href="https://apps.apple.com/us/app/outside-lands/id547295030" title="App Link" v-else-if="mobileOS === 'other'">
    <span class="text">
    APP STORE LINK
    </span>
    </a>
              </div>
            </div>
            <div class="relative col-xs-12 col-sm-6 mt7-ns ph0">
              <div
                class="dn flex-ns absolute bottom-0 left-0 right-0 center flex-row items-center quote-box"
              >
                <p class="f4 tc is-tablet-regular is-beige">
                  {{ post.quote_text | truncate(160, "...") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 pb6 flex flex-column z-content">
          <div class="relative bg-teal pv5 relative">
            <div class="flex flex-column container-fluid relative z-4">
              <h2
                class="f3 is-white center tc ttn lh-copy is-tablet-bold pv4 dib"
                id="outside-lands-app"
              >
                We’ll send you the latest.
              </h2>
              <signup-form class="w-100 mw6 dib form-is-blue"></signup-form>
            </div>
            <div class="dn db-ns absolute bottom-0 right-0 mr3 mb3">
              <img class="mw4" src="/assets/images/bg-icons/ol20-hand-white.svg" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-template>
</template>
<script>
import BgVimeoVideoEmbed from "./bg-vimeo-video-embed.vue";
import Marked from "marked";
import PageTemplate from "./page-template.vue";
import SignupForm from "./signup-form.vue";
export default {
  props: ["pageMarkdownFileName"],
  components: {
    PageTemplate,
    SignupForm,
    BgVimeoVideoEmbed,
  },
  metaInfo() {
    return {
      title: this.post.title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: "description", name: "description", content: this.post.excerpt },
        { vmid: "og:image", property: "og:image", content: this.post.featured_image },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: this.post.featured_image,
        },
      ],
    };
  },
  data() {
    return {
      mobileOS: "",
      bgOpaciy: 0,
      bgScrollStart: 10,
      scrollPos: 0,
      // parallax:null,
    };
  },
  computed: {
    post: function () {
      const postData = this.$store.getters.filterPostsByUrl(this.$route.path);
      console.log(this.$route.path, postData[0]);
      return postData[0];
    },
  },
  filters: {
    marked: function (val) {
      return Marked(val);
    },
  },
  methods: {},
  created() {
    //
  },
  mounted() {
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace("#", "");
        document.getElementById(element).scrollIntoView();
      }, 300);
    }

    const getMobileOS = () => {
      const ua = navigator.userAgent
      if (/android/i.test(ua)) {
        this.mobileOS = "Android"
        return this.mobileOS
      }
      else if (/iPad|iPhone|iPod/.test(ua)){
        this.mobileOS = "iOS"
        return this.mobileOS
      }
      else{
        this.mobileOS = "other"
        return this.mobileOS
      }
    }
    console.log("type of device: ", getMobileOS())
  },
  destroyed() {
    //
  },
};
</script>


// <a class="db mw6 mt4 btn-generic has-red-bg" href="https://play.google.com/store/apps/?hl=en_US&gl=US" title="App Link" v-if="mobileOS === 'Android'"> 
//     <span class="text">
//     APP STORE LINK
//     </span>
// </a>

// <a class="db mw6 mt4 btn-generic has-red-bg" href="https://www.apple.com/app-store/" title="App Link" v-else-if="mobileOS === 'iOS'"> 
//     <span class="text">
//     APP STORE LINK
//     </span>
// </a>

// <a class="db mw6 mt4 btn-generic has-red-bg" href="https://www.google.com/" title="App Link" v-else-if="mobileOS === 'other'">
//     <span class="text">
//     APP STORE LINK
//     </span>
// </a>

//IF STATEMENTS FOR THE DEVICE PLATFORMS